import { ColorEnum } from '@/constants/color'
import BasePrinterIcon from '@/features/ui/icons/components/PrinterIcon'
import { FC } from 'react'

const PrinterIcon: FC = () => <BasePrinterIcon fill={ColorEnum.WHITE} width="24" height="24" />

export default PrinterIcon
